<template>
  <div class="map-item-filter">
    <div
      class="col-sm-12 nopads vehicle-list"
    >
      <span
        class="vehicle-list-title pb-2"
        @click.stop="toggleList"
      >
        {{ $t('map_filters.contract_filter') }}
      </span>
      <div
        v-if="selectedContracts && selectedContracts.length > 0
          && !listOpen"
        class="title col-12 text-center pb-2 pt-0"
        style="color: #BEFF41"
      >
        {{ selectedContracts.length === 1 ? selectedContracts[0].name : ((selectedContracts.length) + ' ' + $t('map_filters.contracts_selected')) }}
      </div>
      <div
        class="vehicle-list-caret"
        :class="{ caret_open: listOpen }"
        @click.stop="toggleList"
      >
        <font-awesome-icon icon="caret-down" />
      </div>

      <div
        class="col-sm-12 nopads map-accordion-content"
        :class="{ 'map-accordion-open': listOpen }"
      >
        <div :class="{ 'm-2': listOpen }">
          <div class="badge-filters__wrapper">
            <div class="badge-filters">
              <span
                  v-for="item in timeFilters"
                  :key="item.value"
                  class="badge m-0"
                  :class="isActiveTimeFilter(item.value) ? 'bg-primary text-white' : 'bg-light text-dark'"
                  style="padding: 0.5em 1em; cursor: pointer;"
                  @click="selectTimeFilter(item.value)"
              >
                {{ item.text }}
              </span>
            </div>
          </div>
          <div class="col-12 pt-0 mt-0">
              <div class="form-check mt-1">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      id="onlyUserOwnedContracts"
                      v-model="onlyUserOwnedContracts"
                      :disabled="loading"
                  />
                  <label class="form-check-label text-light" for="onlyUserOwnedContracts">
                      {{ $t('contracts.only_user_owned_contracts') }}
                  </label>
              </div>
          </div>
          <div class="col-12 py-1" :class="{ 'multiselect-expand': multiselectContractCollectionOpen }">
            <multiselect
              v-model="selectedContractCollectionValue"
              :options="contractCollectionOptions"
              :multiple="false"
              :close-on-select="true"
              label="name"
              track-by="name"
              :searchable="true"
              :internal-search="true"
              :selected-label="$t('common.selected')"
              :select-label="$t('common.select')"
              :deselect-label="$t('common.remove_selection')"
              :placeholder="$t('orders.select_contract_collection')"
              :disabled="!contractCollectionOptions || contractCollectionOptions.length < 1 || isLoadingContracts || loading"
              :max-height="300"
              @open="multiselectContractCollectionOpen = true"
              @close="multiselectContractCollectionOpen = false"
            >
              <template
                #singleLabel="props"
              >
                <span class="option__desc">
                  <span class="option__title">{{ props.option.name }}</span>
                </span>
              </template>
              <template
                #option="props"
              >
                <div class="option__desc">
                  <span class="option__title multiselect_detail_block">{{ props.option.name }}</span>
                </div>
              </template>
              <template #noResult>
                <span>{{ $t('common.not_found') }}</span>
              </template>
              <template #noOptions>
                <span>{{ $t('common.no_results') }}</span>
              </template>
            </multiselect>
          </div>
          <div class="col-12 py-1" :class="{ 'multiselect-expand': multiselectContractOpen }">
            <multiselect
              v-model="multiselectValue"
              :options="contracts"
              :multiple="true"
              :close-on-select="true"
              label="name"
              :custom-label="contractName"
              track-by="name"
              :searchable="true"
              :internal-search="true"
              :selected-label="$t('common.selected')"
              :select-label="$t('common.select')"
              :deselect-label="$t('common.remove_selection')"
              :placeholder="$t('orders.select_contract')"
              :disabled="!contracts || contracts.length < 1 || isLoadingContracts || loading"
              :max-height="300"
              @open="multiselectContractOpen = true"
              @close="multiselectContractOpen = false"
            >
              <template
                #singleLabel="props"
              >
                <span class="option__desc">
                  <span class="option__title">{{ props.option.name + (props.option.contract_number ? ' - ' + props.option.contract_number : '') }}</span>
                </span>
              </template>
              <template
                #option="props"
              >
                <div class="option__desc">
                  <span class="option__title multiselect_detail_block">{{ props.option.name + (props.option.contract_number ? ' - ' + props.option.contract_number : '') }}</span>
                </div>
              </template>
              <template #noResult>
                <span>{{ $t('common.not_found') }}</span>
              </template>
              <template #noOptions>
                <span>{{ $t('common.no_results') }}</span>
              </template>
            </multiselect>
          </div>
          <div class="col-12 py-1" :class="{ 'multiselect-expand': multiselectTaskTypeOpen }">
            <multiselect
              v-model="selectedTaskTypeValues"
              class="map-vehicle-taskType-multiselect"
              :placeholder="$t('contracts.select_task_type')"
              :deselect-label="$t('common.remove_selection')"
              :select-label="$t('common.select')"
              :close-on-select="false"
              :multiple="true"
              :open-direction="'below'"
              label="text"
              track-by="text"
              :searchable="true"
              :internal-search="true"
              :selected-label="$t('common.selected')"
              :options="taskTypeOptions"
              :disabled="!multiselectValue || multiselectValue.length < 1 || loading"
              :max-height="300"
              @open="multiselectTaskTypeOpen = true"
              @close="multiselectTaskTypeOpen = false"
            >
                <template #singlelabel="{ option }">
                    <div class="row nopads option__desc align-items-center">
                        <div class="col-auto nopads">
                            <div
                                v-if="option.value"
                                class="task-type-circle"
                                :style="{ backgroundColor: getTraceColor(logModes.WORK, option.color) }"
                            />
                        </div>
                        <div class="col">
                            <span class="option__title">{{ option.text }}</span>
                        </div>
                    </div>
                </template>
                <template #option="{ option }">
                    <div class="row nopads align-items-center">
                        <div class="col-auto nopads">
                            <div
                                v-if="option.value"
                                class="task-type-circle"
                                :style="{ backgroundColor: getTraceColor(logModes.WORK, option.color) }"
                            />
                        </div>
                        <div class="col">
                              <span class="option__title multiselect_detail_block">
                                {{ option.text }}
                              </span>
                        </div>
                    </div>
                </template>
              <template #noResult>
                <span>{{ $t('common.not_found') }}</span>
              </template>
              <template #noOptions>
                <span>{{ $t('common.no_results') }}</span>
              </template>
            </multiselect>
          </div>
          <div class="col-12 py-1" :class="{ 'multiselect-expand': multiselectOrderOpen }">
            <multiselect
              v-model="selectedOrderValue"
              class="map-order-multiselect"
              :placeholder="$t('contracts.select_order')"
              :deselect-label="$t('common.remove_selection')"
              :select-label="$t('common.select')"
              :close-on-select="true"
              :multiple="false"
              :open-direction="'below'"
              label="text"
              :custom-label="getOrderStringWithInfo"
              track-by="id"
              :searchable="true"
              :internal-search="true"
              :selected-label="$t('common.selected')"
              :options="orderOptions"
              :disabled="!orderOptions || orderOptions.length < 1 || loading"
              :max-height="300"
              @open="multiselectOrderOpen = true"
              @close="multiselectOrderOpen = false"
            >
                <template #singleLabel="{ option }">
                    <div class="row nopads option__desc align-items-center">
                        <div class="col-auto nopads">
                            <div
                                v-if="option.id"
                                class="task-type-circle"
                                :style="{ backgroundColor: option.contract_task_type.task_type.color }"
                            />
                        </div>
                        <div class="col">
                          <span class="option__title">
                            {{ getOrderStringWithInfo(option) }}
                          </span>
                        </div>
                    </div>
                </template>

                <template #option="{ option }">
                    <div class="row nopads align-items-center">
                        <div class="col-auto nopads">
                            <div
                                v-if="option.id"
                                class="task-type-circle"
                                :style="{ backgroundColor: option.contract_task_type.task_type.color }"
                            />
                        </div>
                        <div class="col">
                          <span
                              class="option__title multiselect_detail_block"
                              :class="{ closed: !isOrderOpen(option) }"
                          >
                            {{ getOrderStringWithInfo(option) }}
                          </span>
                        </div>
                    </div>
                </template>

              <template #noResult>
                <span>{{ $t('common.not_found') }}</span>
              </template>
              <template #noOptions>
                <span>{{ $t('common.no_results') }}</span>
              </template>
            </multiselect>
          </div>
          <div class="col-12">
            <div class="badge-filters__wrapper">
              <div class="badge-filters pt-1">
                  <span
                        v-show="selectedContractIds && selectedContractIds.length > 0"
                        class="badge"
                        :class="showContractGeometry ? 'bg-primary text-light' : 'bg-light text-dark'"
                        style="padding: .5em 1em; cursor: pointer"
                        @click="geomOrderSelector = true"
                    >
                      {{ $t('orders.show_geometry') }}
                  </span>

                  <span
                      v-show="selectedContractIds && selectedContractIds.length > 0"
                      class="badge"
                      :class="showContractGeometry ? 'bg-light text-dark' : 'bg-primary text-light'"
                      style="padding: .5em 1em; cursor: pointer"
                      @click="hideOrderGeometry"
                  >
                      {{ $t('map.hide_geometry') }}
                    </span>
              </div>
            </div>
          </div>
          <div class="col-12">
              <div v-if="showContractGeometry" class="form-check form-switch mt-1">
                  <input
                      type="checkbox"
                      id="set-contract-order-geometries-labels"
                      class="form-check-input"
                      :disabled="!selectedContractIds || selectedContractIds.length === 0"
                      :checked="showContractGeometryLabels"
                      @change="updateLabels"
                  />
                  <label class="form-check-label text-light" for="set-contract-order-geometries-labels">
                      {{ $t('areas.show_labels') }}
                  </label>
              </div>
          </div>
          <div class="col-12">
              <div class="form-check form-switch mt-1">
                  <input
                      type="checkbox"
                      id="set-traffic-control"
                      class="form-check-input"
                      :checked="showTrafficControl"
                      @change="toggleTrafficControl"
                  />
                  <label class="form-check-label text-light" for="set-traffic-control">
                      {{ $t('map_filters.select_traffic_control') }}
                  </label>
              </div>
          </div>
          <div
            v-if="contractsError"
            class="text-danger"
          >
            {{ $t('common.error') }}
          </div>
          <div class="row mb-0 pb-0">
            <div class="col-12 nopads text-right">
                <span
                    class="badge bg-light text-dark mb-3 btn btn-outline-light"
                    style="padding: .5em 1em; cursor: pointer;"
                    @click="clearFilters"
                >
                  {{ $t('common.clear_filters') }}
                </span>
            </div>
          </div>
        </div>
      </div>
    </div>
      <base-modal
      v-if="geomOrderSelector"
      size="lg"
      :hide-footer="true"
      :title="$t('orders.show_geometry')"
      @close="geomOrderSelector = false"
    >
      <div class="col-12 pb-2">
        <span>{{ $t('map.show_geometry_hint') }}</span>
      </div>
      <div class="col-12">
        <span style="color: #9e0c0c; font-size: .9em">{{ $t('map.show_geometry_warning') }}</span>
      </div>
      <div class="col-sm-8 mb-2">
          <span class="span-title pl-3">{{ $t('contracts.order_filter') }} </span>
          <div class="row nopads">
              <div class="col-11">
                  <multiselect
                      id="orderStatusSelector"
                      v-model="orderStatuses"
                      :multiple="true"
                      :options="orderStatusValues"
                      :custom-label="value => getStatusString(value)"
                      :searchable="true"
                      :close-on-select="false"
                      :placeholder="$t('orders.select_status')"
                      :select-label="$t('orders.select_state')"
                      :selected-label="$t('common.selected')"
                      :deselect-label="$t('common.remove_selection')"
                  />
              </div>
              <div
                  class="col-1 nopads pt-1"
              >
                  <font-awesome-icon
                      icon="trash"
                      style="color: #636364"
                      class="pointer"
                      @click.stop="clearOrderStatusSelection"
                  />
              </div>
          </div>
      </div>
      <!-- Order selections by contract -->
      <div class="col-12">
        <!-- Iterate through groupedOrderOptions -->
        <div
          v-for="group in groupedOrderOptions"
          :key="group.label"
          class="mb-3"
        >
          <h5>{{ group.label }}</h5>
            <div>
                <div v-for="(option, index) in group.options" :key="option.value" class="row pb-1">
                    <div class="col-1">
                        <input
                            class="form-check-input"
                            type="checkbox"
                            :id="'checkbox-' + index"
                            :value="option.value"
                            v-model="selectedGeometryOrderValues"
                        />
                    </div>
                    <div class="col-8">
                        <label class="form-check-label ms-2 mb-0" :for="'checkbox-' + index" style="font-size: .9em">
                            {{ option.text }}
                        </label>
                    </div>
                    <div class="col-2 align-content-end">
                        <order-status-badge
                            class="d-inline-block"
                            :item-id="option.value"
                            :status="option.status"
                            :edit-allowed="false"
                        />
                    </div>
                </div>
            </div>
        </div>
      </div>
      <hr/>
      <div class="col-12 d-flex justify-content-end">
        <button
          class="btn btn-sm btn-secondary form-button"
          @click.stop="geomOrderSelector = false"
        >
          {{ $t('common.cancel') }}
        </button>
        <button
          class="btn btn-sm btn-success form-button"
          :disabled="!selectedGeometryOrderValues || selectedGeometryOrderValues.length < 1"
          @click.stop="saveSelectedGeometryOrders"
        >
          {{ $t('common.search') }}
        </button>
      </div>
    </base-modal>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import {timeUtils} from '../mixins/TimeUtils'
import {logModes, vehicleHelper} from "../mixins/VehicleMixin";
import {mapHelper} from "@/components/mixins/MapMixin";
import {orderMixin} from "@/components/mixins/OrderMixin";
import {orderStatus, workManagementHelper} from "@/components/mixins/WorkManagementMixin";
import {restApi} from "@/components/mixins/RestApiMixin";
import BaseModal from "@/components/BaseModal";
import OrderStatusBadge from "@/components/contractcalendar/OrderStatusBadge.vue";

const STATUS = {
    ALL: 0,
    UPCOMING: 1,
    INPROGRESS: 2,
    READY: 3,
}
const INIT_STATUS = STATUS.INPROGRESS

export default {
    name: "MapContractFilter",
    components: {OrderStatusBadge, BaseModal},
    mixins: [timeUtils, vehicleHelper, orderMixin, restApi, mapHelper, orderStatus, workManagementHelper],
    data() {
        return {
            listOpen: false,
            loading: false,
            selectedTimeFilter: INIT_STATUS,
            multiselectContractCollectionOpen: false,
            multiselectContractOpen: false,
            multiselectTaskTypeOpen: false,
            multiselectOrderOpen: false,
            geomOrderSelector: false,
            contracts: [],
            contractCollectionOptions: [],
            logModes: logModes,
            multiselectValue: null,
            selectedTaskTypeValues: [],
            selectedGeometryOrderValues: [],
            selectedOrderValue: null,
            selectedContractCollectionValue: null,
            onlyUserOwnedContracts: false,
            allOrders: [],
            allContracts: [],
            orderOptions: [],
        };
    },
    computed: {
        ...mapState({
            isLoadingContracts: (state) => state.contracts.isLoading,
            selectedContractIds: (state) => state.contracts.selectedContractIds,
            selectedContracts: (state) => state.contracts.selectedContracts,
            showContractGeometry: (state) => state.contracts.showContractGeometry,
            showContractGeometryLabels: (state) => state.contracts.showContractGeometryLabels,
            selectedGeometryOrders: (state) => state.contracts.selectedGeometryOrders,
            selectedOrderStatuses: (state) => state.contracts.selectedOrderStatuses,
            showTrafficControl: (state) => state.contracts.showTrafficControl,
            selectedTaskType: (state) => state.contracts.selectedTaskType,
            contractsError: (state) => state.contracts.error
        }),
        orderStatuses: {
            get() {
                return this.selectedOrderStatuses;
            },
            set(statuses) {
                this.selectOrderStatuses(statuses);
            }
        },
        taskTypeOptions() {
            const nullVal = { value: null, text: this.$t('contracts.select_task_type') };
            if (!this.selectedContracts || this.selectedContracts.length === 0 || this.isLoadingContracts) {
                return [nullVal];
            }
            const taskTypes = [];
            for (const contract of this.selectedContracts) {
                for (const item of contract.task_types) {
                    taskTypes.push({
                        value: item.task_type.id,
                        text: item.task_type.name,
                        color: item.task_type.color
                    });
                }
            }
            // TODO - Order task types in alphabetical order!
            return [nullVal, ...taskTypes];
        },
        amountOfFiltersSelected() {
            return (this.selectedTimeFilter ? 1 : 0) + (this.selectedContractIds ? 1 : 0)
        },
        orderStatusValues() {
            return Object.values(orderStatus)
        },
        contractOptions() {
            const nullVal = { value: null, text: this.isLoadingContracts ? this.$t('common.loading') : this.$t('map_filters.select_contract') }
            if ((!this.contracts || !this.contracts.length) || this.isLoadingContracts) {
                return [nullVal]
            }
            return [
                nullVal,
                ...this.contracts.map(item => ({
                    value: item,
                    text: item.name + " - " + (item.customer.name)
                }))
            ]
        },
        timeFilters() {
            return [
                {
                    text: this.$t("common.all"),
                    value: STATUS.ALL,
                },
                {
                    text: this.$t("common.upcoming"),
                    value: STATUS.UPCOMING,
                },
                {
                    text: this.$t("common.in_progress"),
                    value: STATUS.INPROGRESS,
                },
                {
                    text: this.$t("map_filters.contracts_ready"),
                    value: STATUS.READY,
                },
            ]
        },
        groupedOrderOptions() {
            const grouped = {};

            // Filter based on selected order statuses
            let filteredOptions = this.orderOptions;
            if (this.orderStatuses && this.orderStatuses.length > 0) {
                filteredOptions = filteredOptions.filter(option =>
                    this.orderStatuses.includes(option.status)
                );
            }

            // Group options by contract ID
            filteredOptions.forEach(option => {
                const contractId = option.contract_task_type.contract.id;
                if (!grouped[contractId]) {
                    grouped[contractId] = [];
                }
                grouped[contractId].push(option);
            });

            // Convert grouped object to an array with label and options
            return Object.entries(grouped).map(([contractId, options]) => ({
                label: this.getContractLabelById(contractId),
                options: options.map(option => ({
                    value: option.id,
                    text: this.getOrderStringWithInfo(option),
                    status: option.status,
                })),
            }));
        }
    },
    watch: {
        // IDE might not recognize this watcher as used but it is used
        orderStatuses(newStatuses) {
            // update Vuex / parent state
            this.selectOrderStatuses(newStatuses);

            if (!newStatuses || newStatuses.length === 0) {
                // keep selections but remove ids that no longer exist in orderOptions
                const validIds = (this.orderOptions || []).map(o => o.id);
                this.selectedGeometryOrderValues = (this.selectedGeometryOrderValues || []).filter(id =>
                    validIds.includes(id)
                );
            } else {
                const statuses = newStatuses; // array
                this.selectedGeometryOrderValues = (this.selectedGeometryOrderValues || []).filter(id => {
                    const order = (this.orderOptions || []).find(o => o.id === id);
                    return order && statuses.includes(order.status);
                });
            }
        },
        selectedContractIds(val) {
            if (this.contracts && this.contracts.length > 1 &&  (!val || val.length < 1)) {
                this.hideOrderGeometry()
            }
        },
        multiselectValue(val) {
            let contracts = val && val.length > 0 ? val : []
            if (this.hasSelectionChanged(contracts)) {
                this.selectContracts(contracts);
                this.updateMapSettings({ buttons: { selectedContracts: this.getSimpleContracts(contracts) }});
                this.saveMapSettings();
                this.selectedOrderValue = null
                this.selectedTaskTypeValues = []
                this.fetchOrders()
            }
        },
        selectedTimeFilter() {
            this.setContracts()
        },
        onlyUserOwnedContracts() {
            this.setContracts()
        },
        selectedTaskTypeValues() {
            this.setTaskTypes(this.selectedTaskTypeValues)
            // Other existing logic
            if (this.selectedTaskTypeValues && this.selectedTaskTypeValues.length > 0 && this.selectedOrderValue) {
                const selectedTaskTypeIds = this.selectedTaskTypeValues.map(taskType => taskType.value);

                if (!selectedTaskTypeIds.includes(this.selectedOrderValue.contract_task_type.task_type.id)) {
                    this.selectedOrderValue = null;
                }
            }
            this.filterOrders();
        },
        selectedOrderValue(order) {
            this.selectOrder(order ? order.id : null)
        },
        selectedContractCollectionValue(val) {
            this.setContracts()
        },
        contracts() {
           this.initContractSelection()
        }
    },
    mounted() {
        this.initContractSelection()
    },
    methods: {
        ...mapActions('contracts', ['getContracts', 'selectContract', 'setShowContractGeometry', 'setShowContractGeometryLabels', 'setShowTrafficControl',
            'selectTaskType', 'setTaskTypes', 'selectOrder', 'selectContracts', 'selectGeometryOrders', 'selectOrderStatuses', 'clearOrderStatuses']),

        updateLabels(event) {
            this.setShowContractGeometryLabels(event.target.checked)
        },

        hasSelectionChanged(newSelection) {
            const ids1 = new Set(newSelection.map(obj => obj.id));
            const ids2 = new Set(this.selectedContractIds.map(obj => obj.id));
            if (ids1.size !== ids2.size) return true;
            for (const id of ids1) {
                if (!ids2.has(id)) return true;
            }
            return false;
        },

        getSimpleContracts(contracts) {
            if (contracts) {
                let result = []
                contracts.forEach( contract => result.push({id: contract.id, name: contract.name}))
                return result
            }
            return null
        },

        toggleTrafficControl(event) {
            this.setShowTrafficControl(event.target.checked)
        },

        contractName ({ name, contract_number }) {
            return contract_number ? `${name} - ${contract_number}` : `${name}`
        },
        // Helper method to fetch the contract name/label by ID, if needed
        getContractLabelById(contractId) {
            const contract = this.contracts.find(c => String(c.id) === String(contractId));
            return contract ? contract.name : `Contract ${contractId}`;
        },
        getSimpleOrders(orders) {
            if (orders) {
                let result = []
                orders.forEach( order => result.push({id: order.id, name: order.contract_task_type.task_type.name}))
                return result
            }
            return null
        },
        saveSelectedGeometryOrders() {
            let orders = []
            this.selectedGeometryOrderValues.forEach(selectedOrder => orders.push(this.orderOptions.find(o => o.id === selectedOrder)))
            this.selectGeometryOrders(orders);
            this.setShowContractGeometry(orders.length > 0)
            this.updateMapSettings({ buttons: { selectedGeometryOrders: this.getSimpleOrders(orders) }});
            this.updateMapSettings({ buttons: { showContractGeometry: orders.length > 0}});
            this.saveMapSettings();
            this.geomOrderSelector = false
        },
        contractQueryParams(status = INIT_STATUS) {
            const {ALL, UPCOMING, INPROGRESS, READY} = STATUS
            let now = new Date().getTime()
            let params = {}
            if (this.onlyUserOwnedContracts === true) {
                params.onlyUserOwnedContracts = 1
            }
            if (this.selectedContractCollectionValue) {
                params.contract_collection = this.selectedContractCollectionValue.id
            }
            switch (status) {
                case ALL:
                    return params
                case UPCOMING:
                    params.startDate = now
                    return params
                case INPROGRESS:
                    params.open = 1
                    return params
                case READY:
                    params.past = 1
                    return params
                default:
                    return INPROGRESS
            }
        },
        async setContracts() {
            this.loading = true
            let results = await this.getContracts(this.contractQueryParams(this.selectedTimeFilter));
            this.loading = false
            let validatedContracts = []
            this.contractCollectionOptions = []
            if (this.contracts && this.contracts.length > 0 || (results && results.length > 0) ) {
                if (results) {
                    this.contracts = results
                    this.allContracts = results
                }
                // Create a helper set to track the ids of contract collections that have already been processed
                const addedCollectionIds = new Set();

                this.contracts.forEach(contract => {
                    if (contract && contract.contract_collection && contract.contract_collection.id && !addedCollectionIds.has(contract.contract_collection.id)) {
                        // Push the new collection into the options array
                        this.contractCollectionOptions.push({
                            id: contract.contract_collection.id,
                            name: contract.contract_collection.name
                        });
                        // Add the id to the set to prevent future duplicates
                        addedCollectionIds.add(contract.contract_collection.id);
                    }
                });
            }
            let preSelectedContracts = this.getMapSettingsIn(['buttons', 'selectedContracts'], false);
            if(preSelectedContracts && preSelectedContracts.length > 0) {
                preSelectedContracts.forEach(preSelectedContract => {
                    this.contracts.forEach(contract => {
                        if(contract.id === preSelectedContract.id) {
                            validatedContracts.push(contract)
                        }
                    })
                })
                this.selectContracts(validatedContracts)
            }
            this.initMultiselectValue();
        },
        initContractSelection() {
            if (!this.contractsError && (!this.contracts || this.contracts.length === 0)) {
                this.setContracts(INIT_STATUS);
            } else if (this.contracts && this.contracts.length > 0) {
                if (this.selectedContracts) {
                    this.multiselectValue = this.selectedContracts
                }
                this.initMultiselectValue()
            }
        },
        toggleList() {
            this.listOpen = !this.listOpen;
        },
        selectTimeFilter(val) {
            this.selectContracts(null)
            this.selectedTimeFilter = val
        },
        getTraceColor: function (mode, color) {
            if (mode === logModes.WORK) {
                return color
            }
            return '#bcbcbc'
        },
        isActiveTimeFilter(val) {
            return val === this.selectedTimeFilter
        },
        hideOrderGeometry() {
            this.setShowContractGeometry(false)
            this.selectGeometryOrders([])
            this.updateMapSettings({ buttons: { selectedGeometryOrders: [] }});
            this.updateMapSettings({ buttons: { showContractGeometry: false }});
            this.saveMapSettings();
            this.selectedGeometryOrderValues = []
        },
        clearFilters() {
            this.selectedTimeFilter = INIT_STATUS
            this.multiselectValue = []
            this.selectedTaskTypeValues = []
            this.selectedContractCollectionValue = null
            this.selectedOrderValue = null
            this.selectGeometryOrders([])
            this.selectOrder(null)
            this.setShowContractGeometry(false)
            this.setShowContractGeometryLabels(false)
            this.setShowTrafficControl(false)
        },
        clearOrderStatusSelection() {
            this.clearOrderStatuses();
        },
        initMultiselectValue() {
            this.multiselectValue = this.selectedContracts
        },
        fetchOrders() {
            this.orderOptions = []
            this.allOrders = []
            if (this.selectedContracts && this.selectedContracts.length > 0) {
                this.loading = true
                this.restFetchParams(this.orderUrl, {contract: this.selectedContracts.map(item => item.id)}, this.handleOrders)
            }
        },
        handleOrders: function (response) {
            if (response) {
                this.allOrders = response.data
                this.filterOrders()
                this.initGeometryOrders()
            }
            this.loading = false
        },
        filterOrders() {
            // Check if there are selected task types
            if (this.selectedTaskTypeValues && this.selectedTaskTypeValues.length > 0) {
                const selectedTaskTypeIds = this.selectedTaskTypeValues.map(taskType => taskType.value);
                this.orderOptions = this.allOrders.filter(item =>
                    selectedTaskTypeIds.includes(item.contract_task_type.task_type.id)
                );
            } else {
                this.orderOptions = this.allOrders;
            }
        },
        initGeometryOrders() {
            let geomVisible = this.getMapSettingsIn(['buttons', 'showContractGeometry'], false)
            let validatedOrders = []
            this.selectedGeometryOrderValues = []
            if (geomVisible) {
                let preSelectedGeomOrders = this.getMapSettingsIn(['buttons', 'selectedGeometryOrders'], []);
                if (preSelectedGeomOrders && preSelectedGeomOrders.length > 0) {
                    preSelectedGeomOrders.forEach(preSelectedOrder => {
                        this.orderOptions.forEach(order => {
                            if (order.id === preSelectedOrder.id) {
                                validatedOrders.push(order)
                                this.selectedGeometryOrderValues.push(order.id)
                            }
                        })
                    })
                }
            }
            this.selectGeometryOrders(validatedOrders)
            this.setShowContractGeometry(geomVisible)
        }
    }
}
</script>
<style lang="scss" scoped>
.closed {
    color: #9e9d9d;
    font-style: italic;
}
.multiselect-expand {
    height: 330px;
}

.badge.badge-item {
    display: inline-block;       /* Allows width to grow with content */
    padding: 0.5em 1.5em;        /* Add comfortable horizontal space */
    min-width: 70px;             /* Optional: minimum width */
    max-width: 100%;             /* Optional: max width for very long text */
    font-size: 1em;
    text-align: center;
    white-space: nowrap;         /* Prevent text from wrapping to a new line */
    overflow: hidden;            /* Optional: hide overflowed text */
    text-overflow: ellipsis;     /* Optional: show "..." if it overflows */
    box-sizing: border-box;
}

</style>
